var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5984 9.79076C10.4824 9.75842 9.7495 9.47671 10.2075 8.28957H10.2009C11.3947 7.2411 12.307 5.55398 12.307 3.89298C12.307 1.33897 10.3154 9.15527e-05 8.00073 9.15527e-05C5.6846 9.15527e-05 3.70392 1.33835 3.70392 3.89298C3.70392 5.56082 4.61112 7.25478 5.81222 8.30076C6.2804 9.34799 5.44321 9.73665 5.26819 9.79076C2.84412 10.5389 0 11.9014 0 13.2465V13.7508C0 15.5834 4.167 16.0001 8.02334 16.0001C11.8855 16.0001 16 15.5834 16 13.7508V13.2465C16 11.8609 13.142 10.509 10.5984 9.79076ZM6.57575 15.2066C6.57575 13.6215 7.75934 11.4816 7.75934 11.4816L6.94038 10.9337C6.94038 10.4101 8 9.86227 8 9.86227C8 9.86227 9.0567 10.4188 9.0567 10.9337L8.24066 11.4816C8.24066 11.4816 9.42425 13.6134 9.42425 15.224C9.42425 15.4765 6.57575 15.418 6.57575 15.2066Z",
    fill: "url(#paint0_linear_714_15526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_714_15526",
    x1: 12.9922,
    y1: 63.4424,
    x2: -3.95404,
    y2: 62.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPlayer);
export default __webpack_public_path__ + "static/media/adminPlayer.80930be036e24db1bde0522121451a16.svg";
export { ForwardRef as ReactComponent };